/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import PageType from 'linced-app/enums/page-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class SidekickRoute extends Route {
  queryParams = {
    pageId: {
      refreshModel: false,
    },
  };

  // Services
  @service
  store;

  model() {
    let group = this.modelFor('group');
    return hash({
      group,
      learners: this.store.query('person', {
        groupId: group.id,
      }),
      pages: this.store.query('posts/page', {
        type: PageType.STUDENT,
        visibleInMenu: true,
      }),
    });
  }
}
